// src/utils/templateRenderer.js
export function getFlagSet(context = {}) {
  const flags = {};
  const get = (path, fallback) => {
    try {
      return (
        path.split(".").reduce((o, k) => (o ? o[k] : undefined), context) ??
        fallback
      );
    } catch {
      return fallback;
    }
  };

  const discipline = Number(get("characterTraits.discipline", 50));
  flags["discipline_low"] = discipline < 40;
  flags["discipline_mid"] = discipline >= 40 && discipline <= 65;
  flags["discipline_high"] = discipline > 65;

  const mental = Number(get("characterTraits.mentalOpenness", 50));
  flags["mental_low"] = mental < 40;
  flags["mental_high"] = mental > 65;

  const emo = Number(get("characterTraits.emotionalOpenness", 50));
  flags["emotion_low"] = emo < 40;
  flags["emotion_high"] = emo > 65;

  const persp = Number(get("characterTraits.perspective", 50));
  flags["persp_low"] = persp < 40;
  flags["persp_high"] = persp > 65;

  const e = Number(get("personalityTraits.0", 50));
  const a = Number(get("personalityTraits.1", 50));
  const s = Number(get("personalityTraits.2", 50));
  flags["emotional_high"] = e > 65;
  flags["activity_low"] = a < 40;
  flags["sociability_high"] = s > 65;

  return flags;
}

export function renderText(template, context = {}) {
  if (template === null || template === undefined) return "";

  const flags = getFlagSet(context);

  // conditionals [[if:flag]]...[[endif]]
  const conditionalRegex = /\[\[if:([a-zA-Z0-9_]+)\]\]([\s\S]*?)\[\[endif\]\]/g;
  template = template.replace(conditionalRegex, (m, flag, inner) =>
    flags[flag] ? inner : ""
  );

  // placeholders {{path}}
  return template.replace(/\{\{\s*([a-zA-Z0-9_\.]+)\s*\}\}/g, (_, path) => {
    const val = path
      .split(".")
      .reduce((o, k) => (o ? o[k] : undefined), context);
    if (val === undefined || val === null) return "";
    return String(val);
  });
}

export function renderArray(arr, context = {}) {
  if (!Array.isArray(arr)) return [];
  return arr.map((t) => renderText(t, context)).filter(Boolean);
}
